import React from 'react';
import '../components/HomeView/Home.css'
import {TopMenuLinks} from "../components/HomeView/TopMenuLinks";
import {TopMenuLogo} from "../components/HomeView/TopMenuLogo";
import ObLifeguardStation1 from './../img/paintings/IMG_5297.jpg'
import style from './../components/MiniPaintingView/miniPaintingView.module.css'
import pic1 from './../img/mini_paintings/Untitled 1.jpg'
import pic2 from './../img/mini_paintings/Untitled 2.jpg'
import pic3 from './../img/mini_paintings/Untitled 3.jpg'
import pic4 from './../img/mini_paintings/Untitled 4.jpg'
import pic5 from './../img/mini_paintings/Untitled 5.jpg'
import pic6 from './../img/mini_paintings/Untitled 6.jpg'
import pic7 from './../img/mini_paintings/Untitled 7.jpg'
import pic8 from './../img/mini_paintings/Untitled 8.jpg'
import pic9 from './../img/mini_paintings/Untitled 9.jpg'
import pic10 from './../img/mini_paintings/Untitled 10.jpg'
import pic11 from './../img/mini_paintings/Untitled 11.jpg'
import pic12 from './../img/mini_paintings/Untitled 12.jpg'
import pic13 from './../img/mini_paintings/Untitled 13.jpg'
import pic14 from './../img/mini_paintings/Untitled 14.jpg'
import pic15 from './../img/mini_paintings/Untitled 15.jpg'
import pic16 from './../img/mini_paintings/Untitled 16.jpg'
import pic17 from './../img/mini_paintings/Untitled 17.jpg'
import pic18 from './../img/mini_paintings/Untitled 18.jpg'
import pic19 from './../img/mini_paintings/Untitled 19.jpg'
import pic20 from './../img/mini_paintings/Untitled 20.jpg'
import pic21 from './../img/mini_paintings/Untitled 21.jpg'
import pic22 from './../img/mini_paintings/Untitled 22.jpg'
import pic23 from './../img/mini_paintings/Untitled 23.jpg'
import pic24 from './../img/mini_paintings/Untitled 24.jpg'
import pic25 from './../img/mini_paintings/Untitled 25.jpg'
import pic26 from './../img/mini_paintings/Untitled 26.jpg'
import pic27 from './../img/mini_paintings/Untitled 27.jpg'




import {MobileSearchBar} from "../components/HomeView/MobileSearchBar";
import {MiniPaintingItem} from "../components/MiniPaintingView/MiniPaitingItem";


export const MiniPaintingView = () => {

    return <div className='PageBackground'>
        <TopMenuLogo/>
        <MobileSearchBar/>
        <TopMenuLinks/>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            paddingBottom: '10%',
        }} className={style.miniPaintingItemContainer}>
            {/*message*/}
            <div style={{backgroundColor: 'rgb(48,93,150)', width: '100%', padding: '1%'}} className={style.subtitleContainer}>
                <div style={{textAlign: 'center', fontSize: 18, color: 'white'}}>These small, 3"x3" paintings have been nearly a daily practice since my cousin gifted me the book for christmas!  All are painted on-location, with watercolor, fountain pen, and white acrylic pen
                </div>
            </div>
            <div style={{
                paddingRight: '5%',
                paddingLeft: '5%',
                display: 'flex',
                flexDirection: 'row',
                height: '100%',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <MiniPaintingItem name={'Roberta\'s House - 12/25/25'} picture={pic1}/>
            <MiniPaintingItem name={'Roberta\'s Porch - 12/26/25'} picture={pic2}/>
            <MiniPaintingItem name={'Piazza della Famiglia - 12/26/25'} description={"I really don't think they chose a good fountain.  What do dragon-carp looking fish have to do with Little Italy?"} picture={pic3}/>
            <MiniPaintingItem name={'County Admin. Building - 12/27/25'} picture={pic4}/>
            <MiniPaintingItem name={'Seaport Village Carousel - 12/28/25'} picture={pic5}/>
            <MiniPaintingItem name={'Coronado Across the Bay - 12/28/25'} picture={pic6}/>
            <MiniPaintingItem name={'Princess Pub - 12/29/25'} picture={pic7}/>
            <MiniPaintingItem name={'My Exclusive-Use Area - 12/30/25'} picture={pic8}/>
            <MiniPaintingItem name={'Harbor Breakfast - 12/30/25'} picture={pic9}/>
            <MiniPaintingItem name={'Newbreak Coffee - 12/31/25'} picture={pic10}/>
            <MiniPaintingItem name={'Allison\'s House - 12/31/25'} picture={pic11}/>
            <MiniPaintingItem name={'La Pensione - 1/2/26'} picture={pic12}/>
            <MiniPaintingItem name={'Civico 1845 - 1/4/26'} picture={pic13}/>
            <MiniPaintingItem name={'Piazza Lightposts - 1/4/26'} picture={pic14}/>
            <MiniPaintingItem name={'Shorebird - 1/5/26'} picture={pic15}/>
            <MiniPaintingItem name={'Santa Fe Depot - 1/6/26'} picture={pic16}/>
            <MiniPaintingItem name={'OB Lifeguard Station - 1/7/26'} picture={pic17}/>
            <MiniPaintingItem name={'SD Museum of Art - 1/8/26'} picture={pic18}/>
            <MiniPaintingItem name={'Auto Radio Specialists. Inc. - 1/9/26'} picture={pic19}/>
            <MiniPaintingItem name={'SD International Airport - 1/9/26'} picture={pic20}/>
            <MiniPaintingItem name={'Weird Little Car Thing - 1/11/26'} picture={pic21}/>
            <MiniPaintingItem name={'The Template - 1/12/26'} picture={pic22}/>
            <MiniPaintingItem name={'Lofty Coffee - 1/13/26'} picture={pic23}/>
            <MiniPaintingItem name={'La Cabaña - 1/15/26'} picture={pic24}/>
            <MiniPaintingItem name={'Morning Glory - 1/16/26'} picture={pic25}/>
            <MiniPaintingItem name={'Portal Coffee - 1/18/26'} picture={pic26}/>
            <MiniPaintingItem name={'This Planter - 1/19/26'} picture={pic27}/>

            </div>

        </div>
    </div>
}

